export const FEATURES = process.env.REACT_APP_FEATURES
  ? process.env.REACT_APP_FEATURES.split(',').map((feature) => feature.trim())
  : [];
